/**
 * Evidence-related utility functions
 */

/**
 * Generates a descriptive action text based on what evidence was added
 * @param notes - Array of notes or note items
 * @param documents - Array of documents or document items
 * @returns A descriptive string like "added a note", "added attachments", etc.
 *
 * @example
 * getEvidenceActionDescription([{ text: 'note' }], null) // 'added a note'
 * getEvidenceActionDescription(null, [{ name: 'doc.pdf' }]) // 'added an attachment'
 * getEvidenceActionDescription([{ text: 'note' }], [{ name: 'doc.pdf' }]) // 'added a note and attachment'
 * getEvidenceActionDescription(null, [{ name: 'doc1.pdf' }, { name: 'doc2.pdf' }]) // 'added attachments'
 */
export const getEvidenceActionDescription = (
  notes?: Array<unknown> | null,
  documents?: Array<{ name: string; extension: string }> | null,
): string => {
  const hasNotes = notes && notes.length > 0;
  const hasDocuments = documents && documents.length > 0;
  const documentCount = documents?.length || 0;

  if (hasNotes && hasDocuments) {
    return documentCount > 1 ? 'added a note and attachments' : 'added a note and attachment';
  }
  if (hasNotes) {
    return 'added a note';
  }
  if (hasDocuments) {
    return documentCount > 1 ? 'added attachments' : 'added an attachment';
  }
  return '';
};
